import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/img/exam-title.png'


const _hoisted_1 = { class: "result-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "result-title",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "result-content" }
const _hoisted_4 = { class: "result-content-desc" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, "作答的成绩：", -1)
const _hoisted_6 = { style: {"font-size":"8vw"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShareBtn = _resolveComponent("ShareBtn")
  const _component_Canvas = _resolveComponent("Canvas")
  const _component_ShareImg = _resolveComponent("ShareImg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", null, _toDisplayString(_ctx.userInfo.nickname) + "，" + _toDisplayString(_ctx.myResult.isTimeout ? '时间已到，' : '') + "感谢您的作答！", 1),
        _createVNode("div", null, "您共用：" + _toDisplayString(_ctx.myResult.timesStr), 1),
        _hoisted_5,
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.myResult.score) + "分", 1)
      ]),
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.returnHome()))
      }, "返回首页")
    ]),
    _createVNode(_component_ShareBtn, {
      showSave: true,
      onSave: _ctx.saveClick
    }, null, 8, ["onSave"]),
    (_ctx.showShare)
      ? (_openBlock(), _createBlock(_component_Canvas, {
          key: 0,
          onGetpic: _ctx.getCanvasPic
        }, null, 8, ["onGetpic"]))
      : _createCommentVNode("", true),
    (_ctx.showShareImg)
      ? (_openBlock(), _createBlock(_component_ShareImg, {
          key: 1,
          imgSrc: _ctx.base64Src,
          onClose: _ctx.closeShareImg
        }, null, 8, ["imgSrc", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}